import { ErrorBoundary } from 'modules/error';
import { Product, Team } from 'teams';

import { usePanelContext } from '../../contexts/Panel';
import { PanelView } from '../../types';
import { PanelViewDetail } from './PanelViewDetail';
import { PanelViewList } from './PanelViewList';
import { PanelViewRemoteUrl } from './PanelViewRemoteUrl';
import { PanelViewUpload } from './PanelViewUpload';

const getPanelView = (view: PanelView) => {
  switch (view) {
    case PanelView.Detail:
      return PanelViewDetail;
    case PanelView.List:
      return PanelViewList;
    case PanelView.RemoteUrl:
      return PanelViewRemoteUrl;
    case PanelView.Upload:
      return PanelViewUpload;
    default:
      return PanelViewList;
  }
};

export const PanelBody = () => {
  const { panelView } = usePanelContext();
  const View = getPanelView(panelView);

  return (
    <ErrorBoundary teamName={Team.CONTENT_TEAM} productName={Product.CREATIVE_LIBRARY}>
      <View />
    </ErrorBoundary>
  );
};
